import { useColorScheme } from "@mui/joy/styles";
import { useEffect } from "react";

export default function ThemeSync() {
  const { mode } = useColorScheme();

  useEffect(() => {
    const root = document.documentElement;
    if (mode === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
  }, [mode]);

  return null;
}
